import { CircularProgress } from '@mui/material'

export const ValidationCircularSpinner = () => {
  return <CircularProgress sx={{ color: 'secondary.main', mr: 0.5 }} size="16px" thickness={6} />
}
